import { useEffect, useRef } from 'react';

import { useDebounce } from '@cast/utils';

import { SearchProps } from '../types';

export const useAnalytics = (
  analyticsHandler: SearchProps['analyticsHandler'],
  freeText?: string,
  values?: Record<string, any>
) => {
  const debouncedFreeText = useDebounce(freeText, 500);
  const handlerRef = useRef(analyticsHandler);
  useEffect(() => {
    handlerRef.current = analyticsHandler;
  });

  const stableValues = JSON.stringify(values);
  useEffect(() => {
    const parsedValues = stableValues ? JSON.parse(stableValues) : undefined;
    if (debouncedFreeText || Object.keys(parsedValues ?? {}).length) {
      handlerRef.current?.({
        freeText: debouncedFreeText,
        chips: parsedValues,
      });
    }
  }, [debouncedFreeText, stableValues]);
};
